export const useSendToApp = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  const androidSendToApp = (key: string, ...args: unknown[]) => {
    try {
      (window as any).WebViewBridge[key](...args) || null;
    } catch (err) {
      throw err;
    }
  };

  const iosSendToApp = (key: string, ...args: unknown[]) => {
    try {
      (window as any).webkit.messageHandlers[key].postMessage(...args);
    } catch (err) {
      throw err;
    }
  };

  const sendToApp = (key: string, ...args: unknown[]) => {
    try {
      if (userAgent.indexOf('android') !== -1) {
        return androidSendToApp(key, ...args);
      } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
        return iosSendToApp(key, ...args);
      }
      throw 'desktop';
    } catch (err) {
      throw err;
    }
  };

  const isWebView = !!(window as any)?.WebViewBridge || !!(window as any)?.webkit?.messageHandlers;

  return { isWebView, androidSendToApp, iosSendToApp, sendToApp };
};
